export const handleCheckboxChange = (filterObj, e) => {
    if (!e.target.value || !e.target.classList.contains("el__checkbox")) return;

    const existingFilterValue = filterObj.value;
    const targetValue = e.target.value;
    const targetChecked = e.target.checked;
    const updatedFilterValue = [];

    if (existingFilterValue) updatedFilterValue.push(...existingFilterValue);

    if (updatedFilterValue.includes(targetValue) && !targetChecked) {
        const index = existingFilterValue.indexOf(targetValue);
        updatedFilterValue.splice(index, 1);
    } else {
        updatedFilterValue.push(targetValue);
    }

    if (updatedFilterValue.length === 0) return;

    return updatedFilterValue;
};

export const checkboxFilterHandler = (extensions, filterObj) => {
    if (!filterObj.value || !filterObj.targetProperty) return;

    const { value, targetProperty } = filterObj;

    return extensions.filter((extension) => {
        if (!extension[targetProperty]) return false;

        for (const val of value) {
            if (extension[targetProperty].includes(val)) return true;
        }
    });
};

const fillCheckboxesInputValues = (filterEl, values, state) => {
    for (const value of values) {
        const filterValueEl = filterEl.querySelector(`.el__filter-value[id="${value}"]`);

        if (!filterValueEl) continue;

        filterValueEl.checked = state;
    }
};

export const setCheckboxesInputValues = (filterEl, values) =>
    fillCheckboxesInputValues(filterEl, values, true);

export const resetCheckboxesInputValues = (filterEl, values) =>
    fillCheckboxesInputValues(filterEl, values, false);
